// src/theme.js
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#E50914',
      dark: '#B90710',
      light: '#FF4A4F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2D7FF9',
      dark: '#155BD5',
      light: '#73B2FF',
      contrastText: '#ffffff',
    },
    success: {
      main: '#0F9F6E',
    },
    text: {
      primary: '#101828',
      secondary: '#667085',
    },
    background: {
      default: '#F7F8FB',
      paper: '#ffffff',
    },
  },
  shape: {
    borderRadius: 18,
  },
  typography: {
    fontFamily: '"Manrope", "Trebuchet MS", sans-serif',
    h1: {
      fontFamily: '"Barlow Condensed", "Impact", sans-serif',
      fontWeight: 900,
      letterSpacing: '-0.045em',
    },
    h2: {
      fontFamily: '"Barlow Condensed", "Impact", sans-serif',
      fontWeight: 900,
      letterSpacing: '-0.04em',
    },
    h3: {
      fontFamily: '"Barlow Condensed", "Impact", sans-serif',
      fontWeight: 900,
      letterSpacing: '-0.025em',
    },
    h4: {
      fontFamily: '"Barlow Condensed", "Impact", sans-serif',
      fontWeight: 800,
    },
    h5: {
      fontWeight: 800,
    },
    h6: {
      fontWeight: 800,
    },
    button: {
      fontFamily: '"Manrope", "Trebuchet MS", sans-serif',
      fontWeight: 900,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: 'none',
          boxShadow: 'none',
        },
        containedPrimary: {
          boxShadow: '0 18px 36px rgba(229, 9, 20, 0.22)',
          '&:hover': {
            boxShadow: '0 22px 44px rgba(229, 9, 20, 0.28)',
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 800,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);
export default theme;
